import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export class CommonValidators {
  public static email: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const regexp = /^(?=.{1,63}@.{1,255}$)(?=.{6,255}$)[^\s@]+@[^\s@]+\.[a-zA-Z]{2,63}$/;

    return regexp.test(control.value) ? null : { 'invalidEmail': true };
  }

  public static phoneNumber: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const regexp = /^\+?(00)?[1-9]\d{1,14}$|^(\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4})$/;

    return regexp.test(control.value) ? null : { 'invalidUrl': true };
  };

  public static url: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const regexp = /^(https?:\/\/)((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-])*(#[-a-z\d_]*)?$/i;

    return regexp.test(control.value) ? null : { 'invalidUrl': true };
  }
}
